"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Small;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _AbstractTextElement = _interopRequireDefault(require("./AbstractTextElement"));

function Small(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  var classes = (0, _classNames.default)('private-microcopy', className);
  return _react.default.createElement(_AbstractTextElement.default, (0, _extends2.default)({}, rest, {
    className: classes
  }));
}

Small.propTypes = (0, _extends2.default)({}, _AbstractTextElement.default.propTypes);
Small.defaultProps = (0, _extends2.default)({}, _AbstractTextElement.default.defaultProps, {
  tagName: 'small'
});
Small.displayName = 'Small';
module.exports = exports.default;